import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { EventsService } from "src/app/services/event/event.service";
import { MobileDataService } from "src/app/services/mobile-data/mobile-data.service";
import { ConfigService } from "src/app/services/config/config.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";

import { Navigator } from "../../menu/navigator";
import { filter, Subscription } from "rxjs";
import { WebcontentService } from "src/app/services/webcontent/webcontent.service";
import { NavigationEnd, Router } from "@angular/router";
import { LobbyNavigator } from "src/app/services/lobby/lobby-navigator.service";
@Component({
  selector: "app-mobile-navbar",
  templateUrl: "./mobile-navbar.component.html",
  styleUrls: ["./mobile-navbar.component.scss"],
})
export class MobileNavbarComponent implements OnInit, OnDestroy{
  @Input() mobileLobby: string;
  @Input() defaultKeyword = false;
  @Input() selectedKeyword = "";
  @Input() clearStyles = false;
  @Input() scrollable = true;
  @ViewChild("topNavbar", { static: false }) topNavbar: ElementRef;

  public topSelectedItem = null;
  public bottomSelectedItem = null; 
  public scrollSubscription: any;
  public cdn = "";
  public exemptions = ["raf"];
  public sticky = false;
  public isAuthenticated = false;
  public previousSticky = null;
  private sideMenuTabSelectionSubscription : Subscription;
  private routerSubscription: Subscription;
  private highlightKeywordSubscription: Subscription;
  public hideNavbar = false;

  constructor(
    private mobileData: MobileDataService,
    private eventsService: EventsService,
    private userSession: UserSessionService,
    private config: ConfigService,
    private navigator: Navigator,
    private webContentService: WebcontentService,
    private router: Router,
    private lobbyNavigator: LobbyNavigator
  ) {
    this.cdn = this.config.getConfig().CDN_BASEURL;
    
    this.mobileData.getMobileLobbyKeyword().subscribe((keywordSubject) => {
      if (keywordSubject.bottomKeyword) {
        this.bottomSelectedItem = keywordSubject.bottomKeyword.name;
        this.topSelectedItem = null;
      }if(keywordSubject.topKeyword) {
        this.topSelectedItem = keywordSubject.topKeyword;
        const bottomKeyword: any = this.mobileData.mobileBottomKeyWordList.find((k:any) => k.name == keywordSubject.topKeyword.name);
        this.bottomSelectedItem = bottomKeyword ? bottomKeyword?.name : null;
      }
    });
    this.verifyAuth();
    this.eventsService.subscribe("event:login", () => {
      this.verifyAuth();
    });

   
  }

  
  ngOnInit() {
    if(this.mobileData.getCurrentLobbyKeyword() === null) {
      this.mobileData.setMobileLobbyKeyword(this.mobileData.defaultKeyword);
    }
    this.bottomSelectedItem = this.mobileData.defaultKeyword.bottomKeyword.name;
    
    this.eventsService.subscribe('tab:default:casino', () => {
      this.mobileData.setMobileLobbyKeyword(this.mobileData.defaultKeyword);
    });

    this.eventsService.subscribe("event:load:home", () => {
      this.bottomSelectedItem = 'Home';  
    });

    this.router.events
    .pipe(filter((event) => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.hideNavbar = false;
      if (event.url.includes('sports')){
        this.hideNavbar = true; // in sports page, kambi widget has its own bottom nav hence hide our own
      }
      if(event.url.includes('promo')){
        this.bottomSelectedItem = this.mobileData.mobileBottomKeyWordList.find((k:any) => k.name.toLowerCase().includes('promo'))?.name;
      }else if(event.url.includes('/c/')){
        this.bottomSelectedItem = '';
      }

    });

  }

  isModalPage(selectedItem) {
    return (
      selectedItem.action_type == "internalnav" &&
      !!this.exemptions.find((item) => item == selectedItem.action_param)
    );
  }

  onBottomSelected(selectedItem) {
    selectedItem["isBottom"] = true;
    this.bottomSelectedItem = selectedItem.name;
    this.sendSelectedKeyword(selectedItem, {
      topKeyword: null,
      bottomKeyword: selectedItem,
    });

    
    if(!this.isAuthenticated && selectedItem.action_param === "livedealer") {
      this.mobileData.setMobileLobbyKeyword({bottomKeyword: selectedItem});
      this.navigator.toCasino();
      return;
    }
   
    switch(selectedItem.action_type) {
			case 'tab':
				this.navigator.toTab(selectedItem.action_param);
				break;
			case 'externalpageload':
				this.webContentService.updateExternalLink(selectedItem.action_param);
				this.navigator.toTab("c", false, selectedItem.action_param);
				break;
			default:
        if(selectedItem.action_param === "livedealer") {
          this.navigator.toLiveDealer();
        }else {
          this.navigator.toTab(selectedItem.action_param);
        }
				break;
		}
    
  }
  
  sendSelectedKeyword(selectedItem, selectedKeyword) {
      this.mobileData.setMobileLobbyKeyword(selectedKeyword);
  }

  verifyAuth() {
    this.userSession.getAuthenticationStatus().subscribe((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });
  }
  ngOnDestroy() {
    this.sideMenuTabSelectionSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
    this.highlightKeywordSubscription?.unsubscribe();
  }
}
